import React from "react";
import Modal from "../../../../elements/Modal";
import ApplicationDetails from "../../../../modalcontent/ApplicationDetails";

const ApplicationDetailsModal = ({
  open = false,
  close = () => {},
  onApply = () => {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} title={data?.title || ""} size="xl5">
      <ApplicationDetails data={data} onApply={onApply} close={close} />
    </Modal>
  );
};

export default ApplicationDetailsModal;
